var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRedXDont = function SvgIconRedXDont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#D54035"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.116 4.327.742.742-5.197 5.198-.742-.743z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m4.884 4.327-.743.742 5.198 5.198.742-.743z"
  })));
};
export { SvgIconRedXDont as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI3IiBmaWxsPSIjRDU0MDM1Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNOS4xMTYgNC4zMjdIMTAuMTY2VjExLjY3N0g5LjExNnoiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDkuMTE2IDQuMzI3KSIvPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMEgxLjA1VjcuMzVIMHoiIHRyYW5zZm9ybT0ic2NhbGUoLTEgMSkgcm90YXRlKDQ1IC03LjY2NSAtMy43MzIpIi8+Cjwvc3ZnPgo=";